import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import RoutePaths from '../../router/RoutePaths';

import { consumeCode, clearLoginAttemptInfo, getLoginAttemptInfo } from 'supertokens-web-js/recipe/passwordless';
import { Button, message } from 'antd';
import TaskonioLoader from '../../components/UI/Loader';
import Logo from '../../assets/images/logo/favicon.svg?react';
import Icon from '@ant-design/icons';
import { analytics } from '../../analytics/analytics';
import { AnalyticsEvent } from '../../analytics/analyticsEvent';

export default function VerifyEmailRegistration() {
  const [isSameBrowserAndDevice, setIsSameBrowserAndDevice] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    isThisSameBrowserAndDevice()
      .then((isSameBrowser) => {
        setIsSameBrowserAndDevice(isSameBrowser);
        if (isSameBrowser) {
          handleMagicLinkClicked()
            .then((res) => {})
            .catch((e) => {
              console.log(e);
            });
        }
      })
      .catch((error) => {
        console.log(error); // Handle error for isThisSameBrowserAndDevice if necessary
      });
  }, []);

  async function isThisSameBrowserAndDevice() {
    return (await getLoginAttemptInfo()) !== undefined;
  }

  async function handleMagicLinkClicked() {
    setIsLoading(true);
    try {
      const response = await consumeCode();
      console.log(response);

      if (response.status === 'OK') {
        // we clear the login attempt info that was added when the createCode function
        // was called since the login was successful.
        await clearLoginAttemptInfo();
        if (response.createdNewRecipeUser && response.user.loginMethods.length === 1) {
          // user sign up success
          analytics.identify(response.user.id);
          analytics.track(AnalyticsEvent.accountCreated, {
            loginMethod: 'magic_link',
          });
        } else {
          // user sign in success
        }
        navigate(RoutePaths.LoginSelectOrganization);
      } else {
        // this can happen if the magic link has expired or is invalid
        // or if it was denied due to security reasons in case of automatic account linking

        // we clear the login attempt info that was added when the createCode function
        // was called - so that if the user does a page reload, they will now see the
        // enter email / phone UI again.
        await clearLoginAttemptInfo();
        void message.error('Login failed. Please try again');
        navigate(RoutePaths.Signup);
      }
    } catch (err: any) {
      if (err.isSuperTokensGeneralError === true) {
        // this may be a custom error message sent from the API by you.
        void message.error(err.message);
      } else {
        void message.error('Oops! Something went wrong.');
      }
      navigate(RoutePaths.Signup);
    }
  }

  if (!isSameBrowserAndDevice && !isLoading) {
    return (
      <div className="h-[100vh] flex flex-col items-center justify-center gap-5">
        <Icon component={() => <Logo height={'2rem'} />} alt="Taskonio logo" />
        <div className="text-center text-brend-grey-dark text-[32px] font-semibold leading-10">
          Log in to your account
        </div>
        <Button
          size="large"
          type="primary"
          className="w-80 h-[52px] rounded-[28px] text-center text-white text-base font-semibold leading-tight mt-5"
          onClick={handleMagicLinkClicked}
        >
          Continue to Taskonio
        </Button>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center">
      <TaskonioLoader></TaskonioLoader>
    </div>
  );
}
